import { render } from "./CreateEditUserModal.vue?vue&type=template&id=60d2be74"
import script from "./CreateEditUserModal.vue?vue&type=script&lang=js"
export * from "./CreateEditUserModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\projetos\\ethos-reports\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__